/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Header_Shot_DescriptionInputs */



/**
* | output |
* | --- |
* | "SHOT DESCRIPTION" |
*
* @param {Ccsl_Export_Header_Shot_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_header_shot_description = /** @type {((inputs?: Ccsl_Export_Header_Shot_DescriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Header_Shot_DescriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("DESCRIPTION DU PLAN")
	if (locale === "de") return /** @type {LocalizedString} */ ("Schussbeschreibung")
	if (locale === "it") return /** @type {LocalizedString} */ ("DESCRIZIONE DELLA SCATTO")
	if (locale === "ru") return /** @type {LocalizedString} */ ("ОПИСАНИЕ СЪЕМКИ")
	if (locale === "es") return /** @type {LocalizedString} */ ("DESCRIPCIÓN DE LA TOMA")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("镜头描述")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ショットの説明")
	if (locale === "hi") return /** @type {LocalizedString} */ ("शॉट का विवरण")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("DESCRIÇÃO DA TOMADA")
	return /** @type {LocalizedString} */ ("SHOT DESCRIPTION")
});